<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      webFormRespostasRelacaoContratual: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        relacaoContratual: this.campos(),
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.relacaoContratual.nomeIntegrante != '')
          return false
        if(this.relacaoContratual.grauParentesco != '')
          return false;
        if(this.relacaoContratual.orgaoAgentePublico != '')
          return false
        if(this.relacaoContratual.cargoAgentePublico != '')
          return false;
        if(this.relacaoContratual.nomeAgentePublico  != '')
          return false;

        return true;
      },
      deletar(indice) {
        this.webFormRespostasRelacaoContratual.splice(indice, 1);
      },
      editar(indice) {
        const relacaoContratual = this.webFormRespostasRelacaoContratual[indice];
        this.webFormRespostasRelacaoContratual.splice(indice, 1);

        this.relacaoContratual.id = relacaoContratual.id;
        this.relacaoContratual.nomeIntegrante = relacaoContratual.nomeIntegrante;
        this.relacaoContratual.grauParentesco = relacaoContratual.grauParentesco;
        this.relacaoContratual.orgaoAgentePublico = relacaoContratual.orgaoAgentePublico;
        this.relacaoContratual.cargoAgentePublico = relacaoContratual.cargoAgentePublico;
        this.relacaoContratual.nomeAgentePublico = relacaoContratual.nomeAgentePublico;
      },
      async adicionar() {
        const copiaRelacaoContratual = Object.assign(this.relacaoContratual);
        
        this.relacaoContratual = this.campos();
        
        this.webFormRespostasRelacaoContratual.push(copiaRelacaoContratual);

        this.$validator.reset();
      },
      campos() {
        return {
          id: '',
          nomeIntegrante: '',
          grauParentesco: '',
          orgaoAgentePublico: '',
          cargoAgentePublico: '',
          nomeAgentePublico: '',
        }
      }
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Nome do Integrante</th>
            <th>Grau Parentesco</th>
            <th>Orgão Agente Público</th>
            <th>Cargo Agente Público</th>
            <th>Nome do Agente Público</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(relacaoContratual, indice) in webFormRespostasRelacaoContratual">
            <td>{{ relacaoContratual.nomeIntegrante }}</td>
            <td>{{ relacaoContratual.grauParentesco }}</td>
            <td>{{ relacaoContratual.orgaoAgentePublico }}</td>
            <td>{{ relacaoContratual.cargoAgentePublico }}</td>
            <td>{{ relacaoContratual.nomeAgentePublico }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        <tr v-if="webFormRespostasRelacaoContratual.length === 0">
          <td colspan="3" class="text-center">Nenhum registro encontrado.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('nomeIntegrante')}">
          <label class="control-label" for="cnpj">Nome do Integrante</label>

          <input type="text"
                 class="form-control"
                 id="nomeIntegrante"
                 maxlength="100"
                 v-model="relacaoContratual.nomeIntegrante"
                 data-vv-name="nomeIntegrante"
                 data-vv-as="nome do integrante"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nomeIntegrante')">{{ errors.first('nomeIntegrante') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('grauParentesco')}">
          <label class="control-label" for="grauParentesco">Grau Parentesco</label>

          <input type="text"
                 class="form-control"
                 id="grauParentesco"
                 maxlength="20"
                 v-model="relacaoContratual.grauParentesco"
                 data-vv-name="grauParentesco"
                 data-vv-as="grau parentesco"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('grauParentesco')">{{ errors.first('grauParentesco') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('orgaoAgentePublico')}">
          <label class="control-label" for="orgaoAgentePublico">Orgão Agente Público</label>

          <input type="text"
                 class="form-control"
                 id="orgaoAgentePublico"
                 maxlength="30"
                 v-model="relacaoContratual.orgaoAgentePublico"
                 data-vv-name="orgaoAgentePublico"
                 data-vv-as="orgão agente público"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('orgaoAgentePublico')">{{ errors.first('orgaoAgentePublico') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('cargoAgentePublico')}">
          <label class="control-label" for="cargoAgentePublico">Cargo Agente Público</label>

          <input type="text"
                 class="form-control"
                 id="cargoAgentePublico"
                 maxlength="30"
                 v-model="relacaoContratual.cargoAgentePublico"
                 data-vv-name="cargoAgentePublico"
                 data-vv-as="cargo agente público"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('cargoAgentePublico')">{{ errors.first('cargoAgentePublico') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('nomeAgentePublico')}">
          <label class="control-label" for="nomeAgentePublico">Nome do Agente Público</label>

          <input type="text"
                 class="form-control"
                 id="nomeAgentePublico"
                 maxlength="100"
                 v-model="relacaoContratual.nomeAgentePublico"
                 data-vv-name="nomeAgentePublico"
                 data-vv-as="nome do agente público"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nomeAgentePublico')">{{ errors.first('nomeAgentePublico') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-success"
            @click="validar">
            <i class="fa fa-plus"></i> Adicionar integrante
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/WebFormRespostasRelacaoContratual.vue